// Import the new consolidated question structure with all 123+ questions
import { byggskedeFragorNew } from "./fragorData/byggskede-new/index";
import { bruksskedeFragor } from "./fragorData/bruksskede";
import { Fraga } from "@/types/riskbedomning";

// Combine all questions into a single array
// Total: ~65 main questions (41 byggskede + 24 bruksskede) with ~300+ follow-ups
export const fragorData: Fraga[] = [
  ...byggskedeFragorNew,  // 41 main questions covering all byggskede aspects (including 13 särskilda arbetsmiljörisker)
  ...bruksskedeFragor      // 24 main questions covering all bruksskede aspects
];

// Keep the async function available for components that need it
export { getFragorData } from "./fragorData/index";
